export function FormHint({ children }: { children: React.ReactNode }) {
  return (
    <p className="rounded-xl border border-separator/80 bg-fill-quaternary px-4 py-3 text-sm leading-relaxed text-label-secondary">
      {children}
    </p>
  );
}
